// extracted by mini-css-extract-plugin
module.exports = {"moreItems":"az_h6b"};